export const heroStats = [
  { num: "57", label: "时间节点" },
  { num: "06", label: "关键阶段" },
  { num: "120+", label: "公开线索" },
  { num: "实时", label: "持续整理" },
];

export const quickNav = [
  { id: "jianjie", label: "来龙去脉", icon: "ri-archive-line" },
  { id: "shijianxian", label: "全记录时间线", icon: "ri-time-line" },
  { id: "jieduan", label: "阶段拆解", icon: "ri-route-line" },
  { id: "kuailiu", label: "快讯流", icon: "ri-flashlight-line" },
  { id: "yidian", label: "疑点清单", icon: "ri-question-line" },
  { id: "taolun", label: "评论区氛围", icon: "ri-chat-smile-3-line" },
];

export const overviewFacts = [
  {
    tag: "事情的起点",
    title: "一句话定性",
    desc: "这是一起围绕公开截图与多方回应的网络争议事件：由一条信息引爆，经当事人、平台与围观者多轮回应后不断变化定性，最终进入「各说各话、持续发酵」的僵持状态。",
  },
  {
    tag: "核心矛盾",
    title: "两边的说法",
    desc: "支持的一方认为关键证据链完整、逻辑自洽；质疑的一方则指出多处时间错位与口径前后不一。分歧集中在证据的「出处是否可信」与「先后关系」两条线上。",
  },
  {
    tag: "为什么会刷屏",
    title: "传播的燃料",
    desc: "反转不断、人名/账号反复出入、各平台删改不一——每条新截图都在给讨论重新点火，也让「完整时间线」成为围观群众最需要的「课代表式」整理。",
  },
];

export const timelineGroups = [
  {
    phase: "第 1 阶段 · 爆发期",
    phaseId: "baofa",
    date: "06.18 — 06.21",
    state: "热度顶点",
    intro: "一条匿名投稿带出核心截图，关键词在数小时内冲上热搜，讨论从单个平台迅速蔓延至全站。",
    items: [
      { time: "06.18 21:40", tag: "起点", text: "匿名投稿区出现第一条长文与配套截图，初步给出「A 指控 B」的完整陈述，配图包含若干对话记录。" },
      { time: "06.19 02:10", tag: "扩散", text: "原帖被大量转载，第一批「划重点」整理贴出现；不同平台开始出现口径略有差异的二次截图。" },
      { time: "06.19 11:30", tag: "热搜", text: "话题登上平台热搜榜前列，主流讨论区开专楼，涌现首轮站队与反方拆解。" },
      { time: "06.20 09:00", tag: "疑点", text: "有网友指出首张截图的时间戳与投稿时间存在矛盾，质疑截图「被裁剪或拼接」，讨论出现第一次反转。" },
      { time: "06.21 20:15", tag: "对峙", text: "相关账号首次发声否认，同时晒出另一组时间线截图；双方说法第一次正面冲突，评论区明显两极。" },
    ],
  },
  {
    phase: "第 2 阶段 · 发酵期",
    phaseId: "fajiao",
    date: "06.22 — 06.28",
    state: "各说各话",
    intro: "当事人连续发声，陆续补充细节；各路「技术流」开始逐帧核对截图，站队逐渐转向「等锤子」。",
    items: [
      { time: "06.22 10:40", tag: "回应", text: "B 方放出反方时间线长文，逐条反驳 A 方指控，附第三方在场说明；A 方暂未更新。" },
      { time: "06.23 18:05", tag: "技术流", text: "多篇「截图验真」帖出现：Exif、字体、背景一致性与时间戳被逐项比对，结论互有出入。" },
      { time: "06.25 14:30", tag: "新料", text: "疑似第三方聊天记录流出，被两派各自解读为「支持己方」；截图源与真实性仍待确认。" },
      { time: "06.27 09:20", tag: "口径变化", text: "A 方更新声明，措辞从「已掌握全部证据」调整为「证据陆续补充中」，观察者认为态度出现松动。" },
      { time: "06.28 22:00", tag: "僵持", text: "两派专楼持续对线，新增内容多为重复论证；热度小幅回落，但「缺最后一块拼图」成为共识。" },
    ],
  },
  {
    phase: "第 3 阶段 · 缠绕与反转",
    phaseId: "fanzhuan",
    date: "06.29 — 07.05",
    state: "反复横跳",
    intro: "平台介入与第三方下场让定性再度摇摆，「时间对应关系」成为所有人反复核对的核心。",
    items: [
      { time: "06.29 12:10", tag: "第三方", text: "传闻中「关键第三人」实名发声，却给出与两派都不完全吻合的版本，整件事的可信度被进一步打散。" },
      { time: "07.01 16:00", tag: "平台", text: "部分原帖被折叠 / 限流 / 删除，平台侧说明未公开；「是否被公关」成为新一波争议焦点。" },
      { time: "07.03 08:45", tag: "时间错位", text: "一名考据党做出一版「逐分钟对齐表」，标注多处先后矛盾，被大量转载，并被称为「课代表汇总」。" },
      { time: "07.04 21:30", tag: "删改", text: "A、B 双方各有旧帖被编辑或隐藏，编辑记录截图疯传，讨论从「谁对」转向「谁在改」。" },
      { time: "07.05 19:00", tag: "阶段性", text: "主流讨论区开设「终局前夜」专楼，普遍等待最后一组关键证据，热度再次上扬。" },
    ],
  },
  {
    phase: "第 4 阶段 · 回落与沉淀",
    phaseId: "chenji",
    date: "07.06 之后",
    state: "等待定论",
    intro: "事件进入低频更新阶段，围观者由「实时跟进」转为「考古回看」，完整梳理的需求反而更高。",
    items: [
      { time: "07.06 后", tag: "回落", text: "热搜热度自然下降，专楼更新频率从按小时降到按天；新鲜料明显减少，多为人肉考古与二次创作。" },
      { time: "持续", tag: "沉淀", text: "各种「事件全记录 / 始末梳理 / 时间线整理」长文陆续沉淀成合集，成为后来者的主要入口。" },
      { time: "待更新", tag: "待后续", text: "关键方未再给出最终说明；本站将持续关注并同步更新，出现新节点会在本页与快讯流第一时间补录。" },
    ],
  },
];

export const phases = [
  {
    no: "01",
    name: "点燃",
    en: "IGNITE",
    period: "06.18 · 投稿爆发",
    mark: "爆发期",
    tone: "strong",
    text: "匿名投稿携核心截图入场，信息量集中、情绪强烈，是整件事被看见的第一推手。",
    points: ["投稿附带首组截图", "数小时冲上热搜", "各平台开专楼站队"],
  },
  {
    no: "02",
    name: "拉锯",
    en: "STALEMATE",
    period: "06.22 · 双方下场",
    mark: "发酵期",
    tone: "mid",
    text: "当事人先后发声、口径互斥，围观者转向逐条对线，舆论进入典型的「各说各话」。",
    points: ["B 方放出反方时间线", "截图验真帖批量出现", "专楼两级对线"],
  },
  {
    no: "03",
    name: "翻转",
    en: "TWIST",
    period: "06.29 · 第三方下场",
    mark: "反转期",
    tone: "accent",
    text: "平台介入与第三人发声让定性不断摇摆，「先发生的到底是不是它」成为焦点。",
    points: ["关键第三人发声", "原帖被折叠 / 删除", "逐分钟对齐表走红"],
  },
  {
    no: "04",
    name: "冷却",
    en: "COOLDOWN",
    period: "07.06 之后",
    mark: "回落期",
    tone: "quiet",
    text: "新鲜料枯竭，围观从「追更新」变成「补课考古」，完整梳理反成刚需。",
    points: ["热度自然回落", "合集长文沉淀", "等待最终说明"],
  },
];

export const feed = [
  { stamp: "09.04 22:10", type: "汇总", title: "「课代表」版逐分钟对齐表更新至 07.05，补齐此前缺失的 3 个时间节点", hot: "2.1k" },
  { stamp: "09.03 14:35", type: "考古", title: "新一批早期投稿评论区截图被翻出，两派正各自取证解读", hot: "1.4k" },
  { stamp: "08.29 11:02", type: "动态", title: "本站时间线补充「07.01 平台限流」一环的对应页面留存截图", hot: "968" },
  { stamp: "08.24 19:47", type: "讨论", title: "某考据号发布「始末复盘长视频」，播放量三小时破 50 万", hot: "3.3k" },
  { stamp: "08.18 08:20", type: "待证", title: "流传的「终极证据包」经核验为旧截图混剪，真实性存疑，暂不录入主线", hot: "1.9k" },
  { stamp: "08.12 16:58", type: "汇总", title: "评论区「反方技术流帖」合集建立，提供独立于主线的另一阅读入口", hot: "720" },
];

export const clues = [
  { text: "首条截图的时间戳与投稿时间差，始终没有被任何一方给出官方合理解释。", state: "待确认" },
  { text: "06.27 声明口径变化前后，是否存在外部压力介入，目前仅有猜测、无实锤。", state: "关注中" },
  { text: "07.03 那张被广泛转载的「逐分钟对齐表」原始制作者与原始文件尚未现身。", state: "寻找源" },
  { text: "部分被删除原帖的完整版本只存在于个人备份，公开渠道难以逐条复核。", state: "存疑" },
  { text: "最终关键证据是否会在平台外渠道放出，仍无任何时间表。", state: "待更新" },
];

export const comments = [
  { handle: "吃瓜也要讲证据", tag: "高赞 · 9.8k", text: "看完全记录我只想说：真正让事件刷屏的不是谁对谁错，而是截图一张接一张地改、说法一轮接一轮地变，最后谁也说不清先后了。", like: "9.8k", time: "2 小时前" },
  { handle: "划重点小组长", tag: "课代表", text: "建议没时间的同学直接跳到「疑点清单」，那几条才是整件事卡住的真正原因，其他楼基本都在重复论证。", like: "6.2k", time: "5 小时前" },
  { handle: "别站队只记录", tag: "理性讨论", text: "反而觉得 07.03 那张时间对应表最值钱，把两派的说法放到同一条时间轴上，很多矛盾一眼就能看出来。", like: "4.7k", time: "8 小时前" },
  { handle: "路过看看", tag: "路人", text: "这就是我想要的那种汇总，不用自己爬一百个帖子，这边一条线就串完了，收藏了。", like: "3.1k", time: "昨天" },
  { handle: "考古挖坟中", tag: "回看", text: "事情冷却了反而好，现在重新梳理一遍，能明显看到热度是怎么一波波涨上来的。", like: "1.8k", time: "昨天" },
];

export const relatedTerms = [
  "51反差", "51反差事件全记录", "51反差时间线", "51反差来龙去脉", "51反差始末",
  "51反差全程回顾", "事件复盘", "截图验真", "课代表汇总", "反转梳理",
];